import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';

export default css({
  '&.marketer-file-overlay-icons': {
    borderRadius: '3px',
    alignItems: 'center',
    '&--gallery:has(svg)': {
      backgroundColor: `${COLORS.BLACK}75`,
    },
    '&--gallery .marketer-file-overlay-icons__icon': {
      color: COLORS.WHITE,
    },
    '&--list .marketer-file-overlay-icons__icon': {
      color: `${COLORS.BLACK}A0`,
    },
  },
});
